module.exports = __webpack_public_path__ + "img/menu_njjl.8b2cac57.png";